/* eslint-disable import/prefer-default-export */
import AccountsReceivableTotalPreNegotiation from '@/domain/models/AccountsReceivableTotalPreNegotiation';
import TradingPolicy from '@/domain/models/TradingPolicy';
import AccountsReceivableParams from '@/domain/models/preNegotiations/accountsReceivable/AccountsReceivableParams';
import IInstallmentConfigs from '../interfaces/IInstallmentConfigs';

export const validateInstallmentValues = (params: {
  totalFromInstallments: number;
  accountsTotal: AccountsReceivableTotalPreNegotiation;
  hasEqualValuesInstallments: boolean;
  installmentConfigs: IInstallmentConfigs;
  tradingPolicy: TradingPolicy|null;
  accountParamsData: AccountsReceivableParams|null;
}): string|null => {
  const {
    totalFromInstallments,
    accountsTotal,
    hasEqualValuesInstallments,
    installmentConfigs,
    tradingPolicy,
    accountParamsData,
  } = params;

  if (totalFromInstallments > accountsTotal.totalBalanceWithFees) {
    return 'O valor total das parcelas deve ser menor ou igual ao valor total dos títulos.';
  }

  if (tradingPolicy) {
    if (
      installmentConfigs.quantity
      && installmentConfigs.quantity > tradingPolicy.amountInstallments
    ) {
      return 'A quantidade de parcela está inválida.';
    }

    if (!tradingPolicy.differentInstallments && !hasEqualValuesInstallments) {
      return 'As parcelas devem ter os valores totais iguais';
    }

    if (
      tradingPolicy.maximumDiscount
      && (
        (accountsTotal.totalBalanceWithFees - totalFromInstallments)
        > tradingPolicy.maximumDiscount
      )
    ) {
      return `O desconto do valor total deve ser menor do que R$ ${tradingPolicy.maximumDiscount}`;
    }
  }

  if (
    !accountParamsData
    || (
      !accountParamsData.carrier
      || !accountParamsData.nature
      || !accountParamsData.prefix
      || !accountParamsData.type
    )
  ) {
    return 'Parâmetros de título não preenchidos';
  }

  return null;
};
